import Model from 'flarum/common/Model';
export default class SynonymSpecies extends Model {
  gbifId() {
    return Model.attribute('gbifId').call(this);
  }
  scientificName() {
    return Model.attribute('scientificName').call(this);
  }
  acceptedSpecies() {
    return Model.hasOne('acceptedSpecies').call(this);
  }
}
flarum.reg.add('champis-species', 'common/models/SynonymSpecies', SynonymSpecies);